import React from 'react'

import { ApolloProvider } from '@apollo/client'

import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'

import { useOOClient } from 'shared/components/common/oo_client_provider/OOClientProvider'

import PageWrapper from 'public/components/default_template/PageWrapper'
import Account from 'public/components/default_template/online_ordering/account/Account'
import { CartContextProvider } from 'public/components/online_ordering/CartContext'
import { MarketingContextProvider } from 'public/components/online_ordering/MarketingContext'
import { PaymentContextProvider } from 'public/components/online_ordering/PaymentContext'
import { getGlobalNavOverrideForOO } from 'public/components/online_ordering/globalNavUtils'

export const AccountPageContent = ({
  nav,
  footer
}: {
  nav: React.ReactNode
  footer?: React.ReactNode
}) => (
  <div className='defaultTemplate' style={{ background: '#FFFFFF' }}>
    {nav}
    <div className='accountPage'>
      <Account />
    </div>
    {footer}
  </div>
)

export const WrappedAccountPage = () => {
  const { restaurant } = useRestaurant()
  const navOverride = getGlobalNavOverrideForOO(restaurant)
  return (
    <PageWrapper
      Component={AccountPageContent}
      shouldShowPreviewBanner={true}
      navTypeOverride={navOverride}
    />
  )
}

export const ContextualAccountPage = ({
  children
}: React.PropsWithChildren<{}>) => {
  const ooClient = useOOClient()

  return (
    <ApolloProvider client={ooClient}>
      <CartContextProvider>
        <MarketingContextProvider>
          <PaymentContextProvider skipPaymentIntent>
            {children}
          </PaymentContextProvider>
        </MarketingContextProvider>
      </CartContextProvider>
    </ApolloProvider>
  )
}

/**
 * Wraps an Account Page with the Context required outside of a restaurant context
 */
export const RestaurantlessContextualAccountPage = ({
  children
}: React.PropsWithChildren<{}>) => {
  const ooClient = useOOClient()

  return <ApolloProvider client={ooClient}>{children}</ApolloProvider>
}

const AccountPage = () => (
  <ContextualAccountPage>
    <WrappedAccountPage />
  </ContextualAccountPage>
)

export default AccountPage
